import React, { Component, PropTypes } from 'react';
import { Modal } from 'react-bootstrap';
import './startFromLastSlideModal.scss';

export default class StartFromLastSlideModal extends Component {

  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    startFromBeginning: PropTypes.func.isRequired,
    startFromLastSlide: PropTypes.func.isRequired,
    level: PropTypes.number,
    i18n: PropTypes.func.isRequired
  };

  cancel (evt) {
    const { closeModal } = this.props;
    closeModal();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  handleFromBeginning (evt) {
    const { startFromBeginning } = this.props;
    startFromBeginning();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  handleFromLastSlide (evt) {
    const { startFromLastSlide } = this.props;
    startFromLastSlide();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  render () {
    const {
      showModal,
      closeModal,
      level,
      i18n: _
    } = this.props;

    return (
      <Modal show={showModal} onHide={closeModal} className="start-from-last-slide">
        <Modal.Header closeButton>
          <Modal.Title>{_`Start Level ${level}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <h3>
            {_('Resume from where you left off?')}
          </h3>

          <button
              className="btn btn-default"
              onClick={::this.handleFromLastSlide}>
            {_('Yes, take me to the last slide I was on')}
          </button>

          <button
              className="btn btn-default"
              onClick={::this.handleFromBeginning}>
            {_('No, I want to start from the beginning of the level')}
          </button>

        </Modal.Body>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/dashboard/startFromLastSlideModal.jsx